import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const questionHeader: ThemedFunctor = ({ theme }) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.remSize[50]};
  margin-bottom: ${theme.remSize[150]};
`;
